window.scrollToTop = function () {
  const rootEle = document.documentElement
  rootEle.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
